/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamExamidLangsAvailableQueryResponse,
  GetApiV1ExamExamidLangsAvailablePathParams,
  GetApiV1ExamExamidLangsAvailable401,
  GetApiV1ExamExamidLangsAvailable404,
  GetApiV1ExamExamidLangsAvailable500,
} from "../../types/examEvaluationController/GetApiV1ExamExamidLangsAvailable.ts";

function getGetApiV1ExamExamidLangsAvailableUrl(
  examId: GetApiV1ExamExamidLangsAvailablePathParams["examId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/${examId}/langs/available` as const,
  };
  return res;
}

/**
 * @description Retorna a lista de idiomas suportados que ainda não foram adicionados à prova informada, para uso em componentes de seleção ao criar um novo idioma. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas disponíveis para uma prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examId/langs/available}
 */
export async function getApiV1ExamExamidLangsAvailable(
  examId: GetApiV1ExamExamidLangsAvailablePathParams["examId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamExamidLangsAvailableQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamExamidLangsAvailable401
      | GetApiV1ExamExamidLangsAvailable404
      | GetApiV1ExamExamidLangsAvailable500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamExamidLangsAvailableUrl(examId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
